/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_Is_Primary_TeamInputs */

const en_tables_teams_is_primary_team = /** @type {(inputs: Tables_Teams_Is_Primary_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Primary Team`)
};

const de_tables_teams_is_primary_team = /** @type {(inputs: Tables_Teams_Is_Primary_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Primary Team`)
};

/**
* | output |
* | --- |
* | "Is Primary Team" |
*
* @param {Tables_Teams_Is_Primary_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_is_primary_team = /** @type {((inputs?: Tables_Teams_Is_Primary_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_Is_Primary_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_is_primary_team(inputs)
	return de_tables_teams_is_primary_team(inputs)
});